





















import { defineComponent } from "@vue/composition-api";
import { Field, CellGroup, Cell, Button } from "vant";
import axios from "@/helpers/axios";

export default defineComponent({
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button
  },
  data() {
    return {
      phone: "",
      result: null as { name: string; balance: number } | null
    };
  },
  computed: {
    balanceYuan(): string {
      if (!this.result) return "";
      return (this.result.balance / 100).toFixed(2);
    }
  },
  methods: {
    async query() {
      const res = await axios.post("/api/manage/settle/queryAccount", { phone: this.phone });
      this.result = res.data.data;
    }
  }
});
